export const lightblue = "#57B9FF";
export const yellow = "#fad02c";
